export default function Button({ onClick, disabled, isSubmit, label, text }) {
    return (
        <button
            type="button"
            className="btn btn-dark d-flex align-items-center justify-content-center gap-2"
            onClick={onClick}
            disabled={disabled || isSubmit}
        >
            {isSubmit && (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            )}
            {isSubmit ? label : text}
        </button>
    );
};